import { debounce } from "lodash";
import { useCallback } from "react";
import CreateCharacterMpProvider from "@/core/data-provider/data-mp/create-character/create-character-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import {
  HEAD_OVERLAY,
  MAKEUP_OVERLAY_COLORS,
  SKIN_KEYS,
} from "@/domains/createCharacter/constants/headOverlay";
import { CreateCharacterState, setHeadOverlay } from "@/domains/createCharacter/slice";

export default function useChangeHeadOverlay() {
  const dispatch = useAppDispatch();

  const onChange = useCallback(
    async (data: CreateCharacterState["headOverlay"]) => {
      await Promise.allSettled(
        Object.entries(data).map(([_, value]) => CreateCharacterMpProvider.setHeadOverlay(value)),
      );

      dispatch(setHeadOverlay(data));
    },
    [dispatch],
  );

  const randomizeAll = useCallback(
    debounce(async () => {
      const headOverlay = {};
      SKIN_KEYS.forEach((feature) => {
        const variants = Array.from({ length: HEAD_OVERLAY[feature].max }, (_, v) => v);
        const randomVariant = variants[Math.floor(Math.random() * variants.length)];

        headOverlay[feature] = {
          overlayId: HEAD_OVERLAY[feature].id,
          index: randomVariant,
          opacity: Math.floor(Math.random() * 100) / 100,
          firstColor: Math.floor(Math.random() * MAKEUP_OVERLAY_COLORS.length),
          secondColor: Math.floor(Math.random() * MAKEUP_OVERLAY_COLORS.length),
        };
      });

      onChange(headOverlay);
    }, 50),
    [dispatch, onChange],
  );

  return {
    randomizeAll,
    onChange,
  };
}
